import { SortingSelector } from 'searchkit'

 
export class TrackedSortingSelector extends SortingSelector {
    toggleItem(key) {
        const selectedOption = this.props.options.find(opt => opt.field + '_' + opt.order === key)

        if (selectedOption && typeof this.props.triggerCatalogSortFilter === 'function') {
            const sectionType = this.props.sectionType || 'catalog'
            const sortValue = `${selectedOption.field}_${selectedOption.order}`
            this.props.triggerCatalogSortFilter(sectionType, sortValue)
        }

        super.toggleItem(key)
    }
}
